export { default as ArrowNarrowDownSolidIcon } from './ArrowNarrowDownSolidIcon';
